import React from "react";
import { LinkProps } from "react-router-dom";
import { Link as StyledLink } from "./link.styled";

export const Link: React.FC<LinkProps> = (props) => <StyledLink {...props} />;
